<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom news-list-page"
    role="main"
  >
    <on-page-breadcrumbs :data="breadcrumbs" />
    <preamble-block
      :title="title"
      :preamble="preamble"
      align="left"
    />
    <section v-if="news.length">
      <info-post-block
        v-for="(post, index) in news"
        :key="index"
        v-bind="post"
      />
    </section>
    <section
      v-else
      class="news-list-page__no-result"
    >
      <svgicon
        name="Illustrative/QualityBlue"
        :original="true"
        class=""
      />
      <p>Just nu har vi inga återkallelser eller annan information att dela med oss av.</p>
    </section>
  </div>
</template>

<script>
  import '#/Illustrative/QualityBlue'
  import PreambleBlock from '@/vue/blocks/PreambleBlock/preambleBlock'

  export default {
    name: "NewslistPage",
    components: {
      PreambleBlock
    },
    props: {
      title: {
        type: String,
        default: ""
      },
      breadcrumbs: {
        type: Array,
        default: () => []
      },
      preamble: {
        type: String,
        default: ""
      },
      news: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style lang="scss">
.news-list-page {
  .preamble {
    $text-max-width: 57.5rem;

    &__heading {
      margin: 1.5rem 0 1rem;
      max-width: $text-max-width;
      color: $color-brown-dark;

      @include font(rubrik, 7, "black");
    }

    &__text {
      max-width: $text-max-width;
      margin: 1rem 0 0;
      color: $color-brown-dark;
    }
  }

  &__no-result {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    @include font(hand,2, "normal");

    p {
      max-width: 27.1875rem;
      color: $color-brown-dark;
      margin: 0.5rem 0;
      text-align: center;
    }

    .svg-icon {
      width: 9rem;
      height: 9rem;

      @include media-breakpoint-up(lg) {
        width: 12.5rem;
        height: 12.5rem;
      }
    }
  }
}
</style>
